import { Controller, useForm } from "react-hook-form";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { Label } from "../../../components/Label/Label";
import PageTitle from "../../../components/PageTitle/PageTitle";
import HelperService from "../../../utility/HelperService";
import { useEffect, useRef, useState } from "react";
import routePaths from "../../../Navigation/routePaths";
import { BookingInterface, BookingInterfaceStatus, BookingState, createOrUpdateBookingInterface, ProjectOptionInterface, ProjectUnitOptionInterface, } from "../BookingTypes";
import { permissionsInterface, reduxInitialState } from "../../onBoarding/onBoardingTypes";
import { bookingCreateRequest, bookingProjectOptionsRequest, bookingProjectOptionsSuccess } from "../BookingsAction";
import Select from "react-select";
import { SET_PROJECT_UNIT_OPTIONS } from "../../../redux/action_constant";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../components/Grid/Grid";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import WebService from "../../../utility/WebService";
import VarifyOTPModal from "../../../components/VarifyOTPModal";
import { useLocation, useNavigate } from "react-router-dom";
import { encrypt } from "../../../utility/cryptoUtils";
import API from "../../../utility/API-endPoints";
import PaymentSchedule, { PaymentRow } from "../../../components/PaymentSchedule";
import { IoClose } from "react-icons/io5";
import UploadFile from "../../../components/UploadFile/UploadFile";
import DocIcon from "../../../assets/images/doc-icon.svg";
import { BsUpload } from "react-icons/bs";
import PlotDatePicker from "../../../components/PlotDatePicker/PlotDatePicker";

interface propData {
  onSubmit: (params: createOrUpdateBookingInterface) => void;
  getProjectOptions: (params: string) => Promise<void> | void;
  setProjectUnitOptions: (params: ProjectUnitOptionInterface[]) => void;
  setProjectOptions: (params: ProjectOptionInterface[]) => void;
}

const headers: GridHeader[] = [
  {
    title: "Date",
    class: "text-left",
  },
  {
    title: "Name",
    class: "text-left",
  },
  {
    title: "Percentage",
    class: "text-left",
  },
  {
    title: "Amount",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isSorting: false,
    isFilter: false,
    isFreeze: true,
  },
];

const recieptHeaders: GridHeader[] = [
  {
    title: "Date",
    class: "text-left",
  },
  {
    title: "Receipt ID",
    class: "text-left",
  },
  {
    title: "Paying Amount",
    class: "text-left",
  },
  {
    title: "Payment Mode",
    class: "text-left",
  },
  {
    title: "Comment",
    class: "text-left",
  }
];

const CreateBooking = (props: propData) => {
  const bookingData: BookingState = useSelector((state: reduxInitialState) => state.BookingReducer);
  const { handleSubmit, formState: { errors, isValid }, control, watch, register, reset, setValue } = useForm<BookingInterface>({});
  const watchAllFields = watch();
  const navigate = useNavigate();
  const [rows, setRows] = useState<GridRow[]>([]);
  const rowCompute = useRef<GridRow[]>([]);
  const sheduleList = useRef<PaymentRow[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [isLoadingProject, setIsLoadingProject] = useState<boolean>(false);
  const [isLoadingUnit, setIsLoadingUnit] = useState<boolean>(false);
  const [isLoadingSchedule, setIsLoadingSchedule] = useState<boolean>(false);
  const [isLoadingReciept, setIsLoadingReciept] = useState<boolean>(false);
  const [recieptRows, setRecieptRows] = useState<GridRow[]>([]);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const { state } = useLocation();
  const isShowHiddenFields = state?.type ?? false;
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
  const [agentOptions, setAgentOptions] = useState<BookingInterface[]>([]);
  const [agentCommsion, setAgentCommission] = useState<any[]>([{ id: new Date().getTime(), agent_id: null, commission: 0, error: false }]);
  const [fileData, setFileData] = useState<any>(null);


  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "PROJECTS"));
    }
  }, [token])

  useEffect(() => {
    (async () => {
      if (permissions && permissions.can_read) {
        if (window.location.pathname === routePaths.BOOKING_UPDATE.path && bookingData && bookingData.editBooking && !HelperService.isEmptyObject(bookingData.editBooking)) {
          setIsEdit(true);
          reset(bookingData.editBooking);
          const area: number = bookingData.editBooking?.project_units && bookingData.editBooking?.project_units.length > 0 && bookingData.editBooking?.project_units.reduce((acc: number, unit: any) => acc + unit.area, 0);
          setValue("area", area);
          if (isShowHiddenFields == "REAL") {
            setShowHiddenFields(true);
            setValue("rate_per_square_feet", bookingData.editBooking?.guideline_rate);
            setValue("rate_key", Number(bookingData.editBooking?.rate_per_square_feet));
            setValue("cost_key", Number(HelperService.formateDecimal(bookingData.editBooking?.rate_per_square_feet * area)));
            setValue("total_cost", Number(HelperService.formateDecimal(bookingData.editBooking?.guideline_rate * area)));
            setValue('is_session', true);
          } else {
            setValue("is_session", false);
          }
          // getAvailableProjectUnit(bookingData.editBooking.project_id);
          getPaymentSchedule({ project_id: bookingData.editBooking.id, isEdit: true }, isShowHiddenFields == "REAL" ? true : false);
          setValue("type", BookingInterfaceStatus.UPDATE_BOOKING);
          props.setProjectOptions([
            {
              ...bookingData.editBooking?.project,
              value: bookingData.editBooking?.project?.id,
              label: bookingData.editBooking?.project?.project_name,
            },
          ]);
          let project_unit: ProjectUnitOptionInterface[] | any = bookingData.editBooking?.project_units && bookingData.editBooking?.project_units?.map((unit: any) => {
            return { ...unit, value: unit.id, label: unit.unit_name };
          });
          setAgentCommission(bookingData.editBooking?.agent_bookings && bookingData.editBooking?.agent_bookings.length > 0 ? bookingData.editBooking?.agent_bookings.map((agent: any) => ({ id: agent.id, agent_id: agent.agent_id, commission: agent.commission, error: false })) : [{ id: new Date().getTime(), agent_id: null, commission: 0, error: false }]);
          props.setProjectUnitOptions(project_unit);
          getBookingReciept(bookingData.editBooking.id, isShowHiddenFields == "REAL" ? true : false);
          setValue("status", bookingData.editBooking.status);
        } else if (window.location.pathname === routePaths.BOOKING_CREATE.path && bookingData && bookingData.editBooking && !HelperService.isEmptyObject(bookingData.editBooking)) {
          setIsEdit(false);
          setValue("project_id", bookingData.editBooking.project_id);
          getAvailableProjectUnit(bookingData.editBooking.project_id);
          getPaymentSchedule({ project_id: bookingData.editBooking.project_id, isEdit: false }, false);
          setValue("project_unit_id", [bookingData.editBooking.project_unit_id as any]);
          setValue("area", bookingData.editBooking.area);
          setValue("agent_id", bookingData.editBooking?.agent_id);
          setValue("type", BookingInterfaceStatus.CREATE_BOOKING);
          getAvailableProjectUnit(bookingData.editBooking.project_id);
          setValue("created_at", new Date());
          setIsLoadingProject(true);
          await props.getProjectOptions("");
          setIsLoadingProject(false);
        } else if (window.location.pathname === routePaths.BOOKING_CREATE.path) {
          setIsEdit(false);
          reset({});
          getFormatedBookingRow(sheduleList.current);
          setValue("type", BookingInterfaceStatus.CREATE_BOOKING);
          setValue("created_at", new Date());
          setIsLoadingProject(true);
          await props.getProjectOptions("");
          setIsLoadingProject(false);
        } else {
          navigate(routePaths.BOOKING.path);
        }
        getAgentList();
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  const onSubmit = async (data: BookingInterface) => {
    if (sheduleList.current.length == 0) { toast.error("Please add schedule"); return; }
    if (showHiddenFields && !data.booking_form_name) { toast.error("Please upload booking form"); return; };

    if (agentCommsion.length > 0) {
      // validate agent commission
      for (let agent of agentCommsion) {
        if (!agent.agent_id || !agent.commission || agent.commission <= 0) {
          setAgentCommission(agentCommsion.map((agent: any) => {
            if (!agent.agent_id || !agent.commission || agent.commission <= 0) {
              return { ...agent, error: true };
            }
            return { ...agent, error: false };
          }));
          return;
        }
      }
    }
    let pecentage = 0;
    let isDateError = false;
    sheduleList.current.forEach((item) => { pecentage += Number(item.percentage); });
    if (isDateError) { toast.error("Please add date in schedule"); return; }
    if (pecentage > 100.05) {
      toast.error("Percentage should not be greater than 100");
      return;
    }
    if (pecentage < 99.98) {
      toast.error("Percentage should not be less than 100");
      return;
    }
    data.payment_schedule = sheduleList.current.map((item) => {
      return {
        name: item.name,
        percentage: item.percentage,
        payment_date: item.payment_date,
        amount: (Number(data.total_cost) * Number(item.percentage)) / 100,
        a_key: data.cost_key ? encrypt(data.cost_key.toString()) : encrypt(data.total_cost.toString()),
      };
    });
    // Here we calculate the percentage difference between rate_per_square_feet and rate_key
    setValue("agent_bookings", agentCommsion)
    setValue("payment_schedule", data.payment_schedule);
    setValue("type", isEdit ? BookingInterfaceStatus.UPDATE_BOOKING : BookingInterfaceStatus.CREATE_BOOKING);
    generateOTP(data, isEdit ? BookingInterfaceStatus.UPDATE_BOOKING : BookingInterfaceStatus.CREATE_BOOKING);
    // props.onSubmit(data);
  };

  const generateOTP = (data: BookingInterface, type: BookingInterfaceStatus) => {
    WebService.postAPI({ action: `create-or-update/booking-otp`, body: { ...data, type }, id: type == BookingInterfaceStatus.CANCEL_BOOKING ? "cancel_booking_btn" : 'project_create_update_btn' })
      .then((response: any) => { setOpen(true); })
      .catch((error) => { toast.error("Failed to create or update booking"); });
  };

  const onSelectProject = (e: any) => {
    if (e && e.value) {
      reset({});
      setValue("project_id", e ? e.value : "");
      setValue("project_unit_id", [] as any);
      setValue("area", "" as any);
      setValue("rate_per_square_feet", e.guideline_rate || "");
      setValue("total_cost", "" as any);
      getAvailableProjectUnit(e.value);
      getPaymentSchedule({ project_id: e.value, isEdit: false }, showHiddenFields);
      setValue("type", isEdit ? BookingInterfaceStatus.UPDATE_BOOKING : BookingInterfaceStatus.CREATE_BOOKING);
    };
  };

  const onSelectProjectUnit = (e: any) => {
    if (e && e.length) {
      setValue("area", e.reduce((acc: number, curr: any) => acc + (curr.area || 0), 0));
      setValue("total_cost", Number(HelperService.formateDecimal(e.reduce((acc: number, curr: any) => acc + (curr.area || 0) * (watchAllFields.rate_per_square_feet || 0), 0))));
    } else {
      setValue("area", "" as any);
      setValue("rate_per_square_feet", "" as any);
      setValue("total_cost", "" as any);
    }
  };

  const getFormatedBookingRow = (list: any[]) => {
    let rows: GridRow[] = [];
    for (var i in list) {
      let columns: GridColumn[] = [];
      columns.push({ value: list[i].payment_date ? HelperService.getFormatedDate(list[i].payment_date) : "N/A" });
      columns.push({ value: list[i].name ? list[i].name : "N/A" });
      columns.push({ value: list[i].percentage ? list[i].percentage : "0" });
      columns.push({ value: list[i].amount ? list[i].amount : "0" });
      columns.push({ value: ViewDetail(Number(i)) });
      rows.push({ data: columns });
    }
    rowCompute.current = rows;
    setRows([...rowCompute.current]);
  };

  const ViewDetail = (i: number) => {
    return (
      <span className="action-btns">
        <button
          type="button"
          className="cursor-pointer btn btn-delete"
          onClick={() => onDeleteShedule(i)}
        >
          {" "}
          <Trash />{" "}
        </button>
      </span>
    );
  };

  const onDeleteShedule = (i: number) => {
    let list = [...sheduleList.current];
    list = list.filter((item, index) => index !== i);
    sheduleList.current = list;
    getFormatedBookingRow(list);
  };

  const onCloseAddShedule = (data: any) => {
    setIsShow(false);
    sheduleList.current = [...data];
    getFormatedBookingRow(data);
  };

  const getAvailableProjectUnit = (projectId: string) => {
    setIsLoadingUnit(true);
    WebService.getAPI({
      action: `available-units/${projectId}`,
    }).then((response: any) => {
      if (response && response.list) {
        let project_unit: any[] = response.list?.map((unit: any) => { return { ...unit, value: unit.id, label: unit.unit_name }; });
        props.setProjectUnitOptions(project_unit);
      }
      setIsLoadingUnit(false);
    }).catch(error => {
      toast.error("Failed to fetch available project units");
      props.setProjectUnitOptions([]);
      setIsLoadingUnit(false);
    });
  };

  const getPaymentSchedule = (data: any, isRed: boolean) => {
    setIsLoadingSchedule(true);
    WebService.postAPI({ action: `get/payment/schedule`, body: data, is_session: isRed })
      .then((response: any) => {
        if (response && response.result) {
          sheduleList.current = response.result;
          getFormatedBookingRow(response.result);
        }
        setIsLoadingSchedule(false);
      }).catch(error => {
        toast.error("Failed to fetch payment schedule");
        sheduleList.current = [];
        getFormatedBookingRow([]);
        setIsLoadingSchedule(false);
      });
  };

  const cancelBooking = (data: BookingInterface) => {
    WebService.postAPI({
      action: `cancel/booking`,
      body: data,
      id: 'verify-otp-button'
    }).then((response: any) => {
      toast.success("Booking cancelled successfully");
      navigate(-1);
    }).catch(error => {
      toast.error("Failed to cancel booking");
    });
  };

  const getBookingReciept = (bookingId: string, isShowHiddenFields: boolean) => {
    setIsLoadingReciept(true);
    WebService.getAPI({
      action: `booking-reciept/${bookingId}`, is_session: isShowHiddenFields
    }).then((response: any) => {
      if (response && response.result) {
        setRecieptRows(response.result);
      }
      setIsLoadingReciept(false);
    }).catch(error => {
      toast.error("Failed to fetch booking receipt");
      setIsLoadingReciept(false);
    });
  };

  const handleKeyDown = (e: any) => {
    const key = e.key.toLowerCase();
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key.toLowerCase();
    // Check for ctrl+p+t
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
      if (isEdit) {
        if (isShowHiddenFields === "REAL") {
          setValue('is_session', true);
          setShowHiddenFields(true);
        }
      } else {
        setShowHiddenFields(true);
        setValue('is_session', true);
      }
    }

    // Remove the key from the set
    setPressedKeys((prev: any) => {
      const updated = new Set(prev);
      updated.delete(key);
      return updated;
    });
  };

  const getFormateRow = (row: any) => {
    let recieptRows: GridRow[] = [];
    row.forEach((item: any) => {
      let columns: GridColumn[] = [];
      columns.push({ value: item.created_at ? HelperService.getFormatedDate(item.created_at) : "N/A" });
      columns.push({ value: item.receipt_id || "N/A" });
      columns.push({ value: HelperService.getCurrencyFormatter(item.paying_amount) });
      columns.push({ value: item.payment_mode || "N/A" });
      columns.push({ value: item.comment || "N/A" });
      recieptRows.push({ data: columns });
    });
    return recieptRows;
  }

  const getAgentList = () => {
    WebService.getAPI({ action: API.ALL_AGENT_LIST })
      .then((response: any) => {
        setAgentOptions(response.list.map((agent: any) => ({ value: agent.id, label: agent.agent_name, agent_projects: agent.agent_projects })));
      })
      .catch(error => {
        toast.error("Failed to fetch agent list");
        setAgentOptions([]);
      });
  };

  const onUploadFile = (data: any, name: string, size: string) => {
    if (fileData && fileData.length === 1) {
      toast.error("You can not upload more than one file");
      setFileData([...fileData]);
      return;
    }
    const blob = URL.createObjectURL(data);
    var isImageExte = /(\.(jpg|jpeg|png))$/i;
    var isVideo = /(\.(mp4))$/i;
    var isPdf = /(\.(pdf))$/i;
    let type = "";

    if (isImageExte.test(name)) {
      type = "IMAGE";
    } else if (isVideo.test(name)) {
      type = "VIDEO";
    } else if (isPdf.test(name)) {
      type = "PDF";
    }
    uploadFile(data);
  };

  const uploadFile = (data: any) => {
    WebService.fileUploadAPI({ action: `upload/file`, key: "image", file: data, body: { uuid: watchAllFields.uuid, type: "BOOKING" }, id: "project_create_update_btn" })
      .then(async (res: any) => {
        toast.success("File uploaded successfully");
        setValue("booking_form_name", res.file_name);
      })
      .catch(async (error: any) => { });
  };

  const onDeleteImage = () => {
    setValue("booking_form_name", "")
  };

  const uploadXlsxFile = async (file: any) => {
    // read xlsx file and convert to json and update 
    const reader = new FileReader();
    reader.onload = async (event: any) => {
      const data = new Uint8Array(event.target.result);
      const workbook: any = await HelperService.readXlsxFile(data);
      if (workbook && workbook.length > 0) {
        // check workbook has keys name	, percentage, payment_date, amount in array of objects
        const hasRequiredKeys = workbook.every((item: any) => item.name && item.percentage && item.payment_date && item.amount);
        if (!hasRequiredKeys) {
          toast.error("Invalid file format. Please upload a valid payment schedule file.");
          return;
        }
        const scheduleData = workbook.map((item: any) => ({
          name: `${item.name}`,
          percentage: Number(item.percentage),
          payment_date: item.payment_date,
          amount: Number(item.amount),
        }));
        sheduleList.current = scheduleData;
        getFormatedBookingRow(scheduleData);

      }
    };
    reader.onerror = (event) => {
      toast.error("Failed to read the uploaded file");
    };
    reader.readAsArrayBuffer(file);
  };

  const getSignedUrl = (fileName: string) => {
    WebService.postAPI({ action: "get/signed-url", body: { key: `bookings/${fileName}` } })
      .then((res: any) => {
        if (res && res.signed_url) {
          window.open(res.signed_url, "_blank");
        } else {
          toast.error("Failed to get signed URL");
        }
      })
      .catch((error: any) => { toast.error("Failed to get signed URL"); });
  };

  return (
    <div className="app-page page-dashboard" >
      <div className="d-flex justify-content-between align-items-center ">
        <PageTitle title={window.location.pathname === routePaths.BOOKING_UPDATE.path ? "Edit Booking" : "Add New Booking"} backArrow={true} active={showHiddenFields} />
      </div>

      {permissions && permissions.can_read && <Card style={{ height: '100%' }}>
        <Card.Body>
          <form className=" form-style" onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={6}>
                <p className="mb-0 font-18 font-medium">Basic Details</p>
                <hr className="m-0 mb-2" />

                <Row>
                  <Col lg={6}>
                    {/* PROJECT */}
                    <Controller
                      control={control}
                      name="project_id"
                      rules={{ required: true }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Project Name</Form.Label>
                          <span className="text-danger">*</span>
                          <div className="input-group mb-1">
                            <Select
                              isLoading={isLoadingProject}
                              {...register("project_id", { required: true })}
                              isDisabled={isEdit}
                              className="basic-single w-100"
                              classNamePrefix="select"
                              isSearchable={true}
                              options={bookingData?.projectOptions}
                              onChange={(e: any) => {
                                onSelectProject(e);
                              }}
                              value={bookingData?.projectOptions?.find(
                                (option) =>
                                  option.value === watchAllFields.project_id
                              )}
                              placeholder="Select Project"
                            />
                          </div>
                          {errors.project_id && (
                            <div className="login-error mb-3">
                              <Label
                                title={"Please select project"}
                                modeError={true}
                              />
                            </div>
                          )}
                        </Form.Group>
                      )}
                    />
                  </Col>
                  <Col lg={6}>
                    <Controller
                      control={control}
                      name="created_at"
                      rules={{ required: true, }}
                      render={({ field: { onChange } }) => (
                        <Form.Group className="mb-3">
                          <Form.Label>Booking Date</Form.Label>
                          <span className="text-danger">*</span>
                          <div className="input-group mb-1">
                            <div className="col-12 form-group">
                              <PlotDatePicker
                                selected={watch("created_at") ? new Date(watch("created_at")) : null}
                                onChange={(date: any) => onChange(date)}
                                placeholderText="Select Date"
                              />
                              {errors.created_at && (<Label title={"Please Select Booking Date."} modeError={true} />)}
                            </div>
                          </div>
                        </Form.Group>
                      )}
                    />
                  </Col>
                </Row>
                {/* PROJECT UNIT */}
                <Controller
                  control={control}
                  name="project_unit_id"
                  rules={{ required: true }}
                  render={({ field: { onChange } }) => (
                    <Form.Group className="mb-3">
                      <Form.Label>Unit</Form.Label>
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <Select
                          isLoading={isLoadingUnit}
                          className="basic-single w-100"
                          classNamePrefix="select"
                          isDisabled={isEdit}
                          isSearchable={true}
                          isMulti={true}
                          options={bookingData?.projectUnitOptions}
                          onChange={(e: any) => {
                            onChange(e.map((item: any) => item.value));
                            onSelectProjectUnit(e);
                          }}
                          value={
                            bookingData?.projectUnitOptions?.filter((option) => watchAllFields.project_unit_id?.includes(option.value)) ?? []
                          }
                          placeholder="Select Project"
                        />
                      </div>
                      {errors.project_unit_id && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please select unit"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                    // show selected unit resgistration power name list  
                  )}
                />
                {watchAllFields.project_unit_id && watchAllFields.project_unit_id.length > 0 && (
                  <div className="mb-3">
                    <p className="mb-1 font-14 font-medium">Registration Power:</p>
                    <ul className="selected-unit-list">
                      {bookingData?.projectUnitOptions?.filter((option) => watchAllFields.project_unit_id?.includes(option.value)).map((item: any) => (
                        <li key={item.value}>{item.unit_name} - <strong>{item.registration_power}</strong>   and area is {item.area} sq ft and {item.is_mortgage ? "Mortgage" : "No Mortgage"} <br />
                          {item.comment ? `Comment: ${item.comment}` : ""}
                        </li>
                      ))}
                    </ul>
                  </div>)}

                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Intrest on Late Payment</Form.Label>{" "}
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Interest on Late Payment in %"
                          {...register("intrest_on_late_payment", { required: true })}
                          onKeyPress={HelperService.allowNewDecimalValue}
                          value={watchAllFields.intrest_on_late_payment}
                        />
                      </div>
                      {errors.intrest_on_late_payment && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter interest on late payment"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* CUSTOMER DETAILS */}
                <Row>
                  <p className="mb-2 font-14 font-medium">Customer Details </p>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Customer Name</Form.Label>{" "}
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Customer Name"
                          {...register("customer_name", { required: true })}
                          value={watchAllFields.customer_name}
                        />
                      </div>
                      {errors.customer_name && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter customer name"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>

                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Customer Mobile</Form.Label>{" "}
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Customer Mobile"
                          {...register("customer_phone", { required: true })}
                          onKeyPress={HelperService.allowOnlyNumericValue}
                          onKeyUp={(e) => { e.stopPropagation(); e.preventDefault(); HelperService.contactFormatter(e) }}
                          value={watchAllFields.customer_phone}
                        />
                      </div>
                      {errors.customer_phone && (
                        <div className="login-error mb-3">
                          <Label
                            title={"Please enter customer mobile"}
                            modeError={true}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={showHiddenFields ? 6 : 12}>
                    <Form.Group className="mb-3">
                      <Form.Label>{showHiddenFields ? "Guideline rate" : "Rate per sq ft"}</Form.Label>{" "}
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder={showHiddenFields ? "Guideline rate" : "Rate per sq ft"}
                          {...register("rate_per_square_feet", { required: true })}
                          onKeyPress={HelperService.allowNewDecimalValue}
                          onBlur={(e) => {
                            setValue(
                              "total_cost",
                              Number(HelperService.formateDecimal(watchAllFields.rate_per_square_feet *
                              watchAllFields.area))
                            );
                          }}
                          value={watchAllFields.rate_per_square_feet}
                        />
                      </div>
                      {errors.rate_per_square_feet && (
                        <div className="login-error mb-3">
                          <Label title={"Please enter rate"} modeError={true} />
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {showHiddenFields && <Col lg={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Rate per sq ft</Form.Label>{" "}
                      <span className="text-danger">*</span>
                      <div className="input-group mb-1">
                        <input
                          type="text"
                          className="form-control ps-3 p-2"
                          placeholder="Rate per sq ft"
                          {...register("rate_key", { required: true })}
                          onKeyPress={HelperService.allowNewDecimalValue}
                          onBlur={(e) => {
                            setValue(
                              "cost_key",
                              Number(HelperService.formateDecimal(watchAllFields.rate_key *
                              watchAllFields.area))
                            );
                          }}
                          value={watchAllFields.rate_key}
                        />
                      </div>
                      {errors.rate_key && (
                        <div className="login-error mb-3">
                          <Label title={"Please enter rate"} modeError={true} />
                        </div>
                      )}
                    </Form.Group>
                  </Col>}
                </Row>

                <Form.Group className="mb-3 font-18">
                  <Form.Label>
                    Total Area :-{" "}
                    {watchAllFields.area ? watchAllFields.area + " sq ft" : ""}{" "}
                  </Form.Label>
                  <Form.Label className="ms-5">
                    {showHiddenFields ? "Guideline Cost" : "Total Cost"} :- {HelperService.getCurrencyFormatter(watchAllFields.total_cost)}
                  </Form.Label>

                  {showHiddenFields && <Form.Label className="ms-5">
                    Total Cost :- {HelperService.getCurrencyFormatter(watchAllFields.cost_key)}
                  </Form.Label>}
                </Form.Group>

                {agentCommsion && agentOptions && agentCommsion.length > 0 && <table className="table table-style-1 mt-2 border">
                  <thead>
                    <tr>
                      <th>Agent</th>
                      <th>Commission</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {agentCommsion.map((item: any) => {
                      return (
                        <tr key={item.id}>
                          <td><Form.Group className="mb-3">
                            <div className="input-group mb-1">
                              <Select
                                className="basic-single w-100"
                                classNamePrefix="select"
                                isSearchable={true}
                                options={agentOptions}
                                isDisabled={!watchAllFields.project_id}
                                onChange={(e: any) => {
                                  const commission = e.agent_projects && e.agent_projects.length > 0 ? e.agent_projects.find((project: any) => project.project_id == watchAllFields.project_id)?.commission : 0;
                                  setAgentCommission(agentCommsion.map((agent: any) => {
                                    if (agent.id === item.id) return { ...agent, commission: commission, agent_id: e.value }
                                    return agent;
                                  }))
                                }}
                                value={agentOptions?.find((option: any) => option.value == item.agent_id)}
                                placeholder="Select Agent"
                              />
                            </div>
                            {item.error && (<div className="login-error mb-3"> <Label title={"Please select agent"} modeError={true} /> </div>)}
                          </Form.Group></td>
                          <td>
                            <input
                              type="text"
                              id={`agentProject-${item.id}`}
                              className="form-control input"
                              name={`agentProject-${item.id}`}
                              onKeyPress={HelperService.allowNewDecimalValue}
                              value={item.commission ? item.commission : ""}
                              onChange={(e: any) => setAgentCommission(agentCommsion.map((agent: any) => {
                                if (agent.id === item.id) return { ...agent, commission: e.target.value }
                                return agent;
                              }))}
                              placeholder="Enter commission"
                              disabled={!watchAllFields.project_id || !item.agent_id}
                            />
                            {item.error && <div className="login-error mb-3"> <Label title={'Please enter a valid commission'} modeError={true} /> </div>}
                          </td>
                          <td className="text-center">
                            <button type="button" className="btn btn-delete border p-1" onClick={() => { setAgentCommission([...agentCommsion, { id: new Date().getTime(), agent_id: null, project_id: null, commission: 0 }]) }}>
                              <Plus /> Add
                            </button>
                            {agentCommsion.length > 1 && <button type="button" className="btn btn-delete border ms-2 p-1" onClick={() => setAgentCommission(agentCommsion.filter((agent: any) => agent.id !== item.id))}>
                              <IoClose />
                            </button>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                }

                {/* booking_form_name */}
                {
                  showHiddenFields && <>
                    {!watchAllFields.booking_form_name && <UploadFile
                      key={new Date().getTime()}
                      onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                      acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                      message="Upload or Drag and Drop Booking Form here"
                      acceptedSize={5}
                    />}

                    {(watchAllFields.booking_form_name) &&
                      <Card className={`border p-2 d-inline-block px-3 mb-3 me-2 h-auto`} >
                        <div className="d-flex gap-3 align-items-center">
                          <div className="me-1">
                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                          </div>
                          <div><img src={DocIcon} width={40} height={40} alt="" /></div>
                          <div>
                            <p className="font-medium font-16 mb-0 cursor-pointer" onClick={() => getSignedUrl(watchAllFields.booking_form_name || "")}>{watchAllFields.booking_form_name}</p>
                          </div>
                        </div>
                      </Card>}
                  </>
                }

              </Col>

              <Col lg={6}>
                <div className="d-flex justify-content-between align-items-center ">
                  <p className="mb-0 font-18 font-medium">Payment Schedule</p>
                  <div>
                    <Button
                      className="btn-brand-1 w-20 me-2"
                      type="button"
                      id="schedule_upload_booking_btn"
                      onClick={() => document.getElementById('fileInput')?.click()}
                      disabled={showHiddenFields ? !watchAllFields.cost_key : !watchAllFields.total_cost}
                    >
                      <BsUpload /> Upload Schedule
                    </Button>
                    <input type="file" id="fileInput" style={{ display: 'none' }} accept=".xlsx, .xls" onChange={(e) => {
                      const file = e.target.files ? e.target.files[0] : null;
                      if (file) {
                        uploadXlsxFile(file);
                      }
                    }} />

                    <Button
                      className="btn-brand-1 w-20"
                      type="button"
                      id="schedule_booking_btn"
                      onClick={() => { setIsShow(true); }}
                      disabled={showHiddenFields ? !watchAllFields.cost_key : !watchAllFields.total_cost}
                    >
                      Manage Payment Schedule
                    </Button>
                  </div>


                  {/* <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="btn btn-brand-1">
                      <Plus size={20} className="ms-1" /> Add
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => { onClickAddSchedule('EMI'); }}>EMI</Dropdown.Item>
                      <Dropdown.Item onClick={() => { onClickAddSchedule('CUSTOM'); }}>Custom</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
                <Grid rows={rows} headers={headers} ShowLoader={isLoadingSchedule} />

                {isEdit && <>
                  <div className="d-flex justify-content-between align-items-center ">
                    <p className="mb-0 font-18 font-medium">Payment Receipts</p>
                  </div>
                  <Grid rows={getFormateRow(recieptRows)} headers={recieptHeaders} ShowLoader={isLoadingReciept} errorMessage="No Reciept Found" />
                </>}
              </Col>

              {isEdit ?
                <>
                  <Col lg={3}></Col>
                  <Col lg={3} className="text-center">
                    {watchAllFields.status == "ACTIVE" && <Button className="btn-brand-1 me-3 w-100 mt-2" type="submit" id="project_create_update_btn">
                      Update
                    </Button>}
                  </Col>
                  <Col lg={3} className="text-center">
                    {watchAllFields.status == "ACTIVE" && <Button className="bg-danger me-3 w-100 btn-outline-danger text-bg-dark mt-2" type="button" id="cancel_booking_btn" onClick={() => { setValue("type", BookingInterfaceStatus.CANCEL_BOOKING); generateOTP(watchAllFields, BookingInterfaceStatus.CANCEL_BOOKING); }}>
                      Cancel booking
                    </Button>}
                  </Col>
                </>
                :
                <>
                  <Col className="mt-2" lg={4}></Col>
                  <Col lg={4} className="text-center">
                    <Button className="btn-brand-1 me-3 w-100 mt-2" type="submit" id="project_create_update_btn">
                      Save
                    </Button>
                  </Col>
                </>}
            </Row>
          </form>
        </Card.Body>
      </Card>}

      {/* <AddScheduleModal type={scheduleType} minDate={startDate} maxDate={endDate} data={sheduleEdit} isShow={isShow} isClose={(data: any) => { onCloseAddShedule(data); }} showDate /> */}
      {isShow && <PaymentSchedule isShow={isShow} isClose={(data: any) => { setIsShow(false); }} totalAmount={showHiddenFields ? watchAllFields.cost_key : watchAllFields.total_cost} initialRows={sheduleList.current} onSubmit={(rows) => { setIsShow(false); onCloseAddShedule(rows); }} />}
      <VarifyOTPModal isShow={open} resendOtp={() => { generateOTP(watchAllFields, watchAllFields.type); }}
        close={() => { setValue("otp", "" as any); setOpen(false); }} message={watchAllFields.customer_phone}
        onSubmit={(otp: number) => {
          let encryptedRateKey;
          if (showHiddenFields) {
            encryptedRateKey = isNaN(Number(watchAllFields.rate_key)) ? watchAllFields.rate_key : encrypt(watchAllFields.rate_key.toString());
          } else {
            encryptedRateKey = encrypt(watchAllFields.rate_per_square_feet.toString());
          }
          // const encryptedRateKey = isNaN(Number(watchAllFields.rate_key)) ? watchAllFields.rate_key : encrypt(watchAllFields.rate_key.toString());
          setValue("otp", otp);
          watchAllFields.type == BookingInterfaceStatus.CANCEL_BOOKING ? cancelBooking({ ...watchAllFields, otp }) :
            props.onSubmit({
              data: { ...watchAllFields, ...{ otp: otp, rate_key: encryptedRateKey } },
              isEdit: isEdit,
              file: (!isEdit && fileData) ? fileData.file : null
            })
        }} />
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onSubmit: (params: createOrUpdateBookingInterface) =>
    dispatch(bookingCreateRequest(params)),
  getProjectOptions: (params: string) =>
    dispatch(bookingProjectOptionsRequest(params)),
  setProjectUnitOptions: (params: ProjectUnitOptionInterface[]) =>
    dispatch({ type: SET_PROJECT_UNIT_OPTIONS, payload: params }),
  setProjectOptions: (params: ProjectOptionInterface[]) =>
    dispatch(bookingProjectOptionsSuccess(params)),
});

export default connect(null, mapDispatchToProps)(CreateBooking);